import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TableTd, TableRow } from '../General/Table';
import { getInvoiceDetailInfo } from '../../../utilities/selectors';
import { SvgIcon, IconType } from '../General/SvgIcon';

export interface Props {
  download: (publicId) => void;
  theme: any;
  publicId: string;
  showInvoice: boolean;
}

function InvoiceRow({ showInvoice, download, theme, publicId }: Props) {
  // const {
  //   invoiceNr,
  //   sumPrice,
  //   invoicePath,
  //   invoiceFileName,
  //   notPaid,
  // } = getInvoiceDetailInfo(invoice);

  return (
    <StyledTableTd>
      <FileWrapper>
        <SvgIcon
          icon={IconType.download}
          alt="Stiahnuť faktúru"
          title="Stiahnuť faktúru"
          marginRight={8}
          width={24}
          height={24}
          viewBox="0 0 18 18"
          fill={theme.colors.textPrimary}
          cursor={showInvoice ? 'pointer' : ''}
        />
        <StatusText
          showInvoice={showInvoice}
          // tslint:disable-next-line:jsx-no-lambda
          onClick={() => download(publicId)}
        >
          {__('Stiahnuť ')}
        </StatusText>
      </FileWrapper>
    </StyledTableTd>
  );
}

const StatusText = styled(TextP)<{ color?: string; showInvoice?: boolean }>`
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: ${rem(14)};
  line-height: ${rem(18)};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.font.primary};
  pointer-events: ${({ showInvoice }) => (showInvoice ? 'auto' : 'none')};
`;

const FileWrapper = styled(FlexRowCenterVertical)<{ showInvoice?: boolean }>`
  opacity: ${({ showInvoice }) => (showInvoice ? '1' : '0.4')};
  cursor: ${({ showInvoice }) => (showInvoice ? 'pointer' : 'auto')};
`;

const StyledTableTd = styled(TableTd)`
  padding: ${rem(16)};
  padding-right: ${rem(56)};
  padding-left: 0;
`;

const WithThemeRow: any = withTheme(InvoiceRow);
export { WithThemeRow as InvoiceRow, StyledTableTd };
